import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {NbCardModule, NbCheckboxModule, NbLayoutModule} from '@nebular/theme';

import {LoginComponent} from './login/login.component';
import {AuthComponent} from './auth.component';
import {AuthRoutingModule} from './auth-routing.module';
import {SharedModule} from '../shared/shared.module';

@NgModule({

  declarations: [
    LoginComponent,
    AuthComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    NbLayoutModule,
    NbCardModule,
    NbCheckboxModule,
    SharedModule,
  ],
})

export class AuthModule {

}
